<gl-cart-end-warning-modal-v2 *ngIf="showWarningDialog" (goToCartEvent)="handleGoToCart()" (closeModal)="handleClose()">
</gl-cart-end-warning-modal-v2>
<gl-cart-emptied-notification-modal-v2 *ngIf="showEmptiedDialog" (closeModal)="handleClose()">
</gl-cart-emptied-notification-modal-v2>
<div class="v4-header__info flex items-center gap-4">
    <a
        class="v4-header__info-link-static hover:no-underline"
        [routerLink]="'/purchase-v2/cart' | localize"
        attr.aria-label="{{ 'SHOPPING_CART_BASKET_ARIA_LABEL' | translate }} {{ getCount() }} {{
            'ITEMS_BASKET_ARIA_LABEL' | translate
        }}">
        <span class="v4-header__info-icon icon icon-basket">
            <span class="v4-header__info-amount">{{ getCount() }}</span>
        </span>
    </a>
    <a class="v4-header__info-link-static flex gap-4" [routerLink]="'/purchase-v2/cart' | localize">
        <div class="gl-light:text-secondary text-base text-primary dark:text-contrast-yellow">{{ timer$ | async }}</div>
    </a>
</div>
